export default __webpack_public_path__ + "static/media/XEMP-26.1cbb081b.jpg";